import React, { Component } from 'react'
import { connect } from 'react-redux'
import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';
import {isSafari} from 'react-device-detect';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import moment from 'moment';
import { getAllEvents, createEvent, renderLoading, renderDone } from '../../../actions/events-actions';
import { getAllUsers } from '../../../actions/admin-actions';
import { getBadgeColor, setDefaultView, getSettingsCredentials } from '../../../actions/user-actions';
import { getTickers } from '../../../actions/tickers-actions';

import calendarStyles from '../styles/calendar.module.scss';
import { Row, Col } from 'react-flexbox-grid';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaPlus } from "react-icons/fa";
import { ToastsStore } from 'react-toasts';

import '../styles/calendarStyles.scss';
import ViewSelector from './ViewSelector';
import { interceptor } from '../../../services/interceptor-service';
import ApiCalendar from 'react-google-calendar-api';
import "isomorphic-fetch";
import { Client } from '@microsoft/microsoft-graph-client';
import { calendarFunctions } from '../../../helpers/calendar-functions';
import { taskTemplate, checkTemplate, weatherTemplate, reminderTemplate, noteTemplate } from '../templates'
import { RRule, Frequency } from 'rrule';
import ConfirmationModal from '../../../components/ConfirmationModal';

export class TUICalendar extends Component {
    calendarRef = React.createRef();
    user = JSON.parse(localStorage.getItem('user'));
    authOutlookData = {};
    constructor(props) {
        super(props);

        this.state = {
            view: this.props.defaultView,
            rangeLabel: '',
            myEvents: [],
            allEvents: [],
            eventsGoogle: [],
            eventsOutlook: [],
            liveliColor: '',
            //eventsGoogle: localStorage.getItem('showGoogle') === 'true' ? JSON.parse(localStorage.getItem('eventsGoogle')) : [],
            //eventsOutlook: localStorage.getItem('showOutlook') === 'true' ? JSON.parse(localStorage.getItem('eventsOutlook')) : [],
            addTaskButtons: [],
            showGoogle: false,
            showOutlook: false,
            viewModalCalendar: false,
            calendarSource: '',
            browserEmail: '',
            syncEmail: '',
            reloadGoogle: false,
            reloadOutlook: false,
            changeDate: false,
            isFirstUpdate: false,
            calendars: [],
            hourStart: 6,
            date: {
                month: 0,
                year: 0
            },
            refresh: false
        }
        ApiCalendar.onLoad(() => {
            ApiCalendar.listenSign(this.signUpdate);
        });
    }

    signUpdate = () => {
        if (localStorage.getItem("refreshGoogle") && ApiCalendar.sign)
            this.eventsGoogle()
    }

     // Resize week grid UI
    rowResize = () => {
        setTimeout(() => {
            let tickerHeight = 0;
            const calendarCont = document.querySelector(
                ".tui-full-calendar-layout"
            );
            const dayGrid = document.querySelector(
                'div[data-auto-height="true"]'
            );
            [...document.querySelectorAll(".tui-full-calendar-left")].forEach(x => {
                if (x.clientHeight) tickerHeight += x.clientHeight;
            });
            let dayHeight = calendarCont.clientHeight - tickerHeight - 49;
            dayGrid.style.height = `${dayHeight}px`;
        }, 150);
    };

    componentDidMount() {
        this.updateRange(false, true);
        this.props.getSettingsCredentials()
        window.addEventListener('resize', () => {
            this.rowResize();
        });
        localStorage.setItem("refreshGoogle", "true");
        //this.inspector();
    }

    componentDidUpdate(prevProps) {
        //== Hiding my tasks
        var el = document.querySelectorAll('[data-panel-index]')[0];
        el.classList.add('hide-element');

        if (!this.props.loading && !prevProps.eventsError && this.props.eventsError) {
            interceptor.removeTokens();
            window.location.href = '/';
        }

        if (prevProps.saving && !this.props.saving && this.props.updateEventsSuccess) {
            ToastsStore.success(this.props.isEditing ? 'Event Updated' : 'Event Saved');
        }

        if (this.props.allForecastsFetched && !prevProps.allForecastsFetched) {
            if (localStorage.getItem('showGoogle') === 'true' && !this.state.reloadGoogle){
                if (!this.setState.changeDate && !this.state.isFirstUpdate) {
                    this.eventsGoogle();
                    this.setState({reloadGoogle: true, isFirstUpdate: true})
                }
                this.setState({changeDate: false})
            }

            if (localStorage.getItem('showOutlook') === 'true' && !this.state.reloadOutlook){
                if (!this.state.isFirstUpdate){
                    this.getOutlookEvents();
                    this.setState({reloadOutlook: true, isFirstUpdate: true})
                }
            }

            const calendarInstance = this.calendarRef.current.getInstance();
            const start = moment(calendarInstance.getDateRangeStart().toDate());
            const end = moment(calendarInstance.getDateRangeEnd().toDate());
            const hourStart = this.getMinimumHour(start, end, true)

            this.setState({
                hourStart,
                myEvents: this.props.eventsToShow,
                allEvents: [
                    ...this.props.eventsToShow,
                    ...this.state.addTaskButtons,
                    ...localStorage.getItem('showGoogle') === 'true' ? JSON.parse(localStorage.getItem('eventsGoogle')) : [],
                    ...localStorage.getItem('showOutlook') === 'true' ? JSON.parse(localStorage.getItem('eventsOutlook')) : [],
                ],
                showGoogle: localStorage.getItem('showGoogle') === 'true' ? true : false,
                showOutlook: localStorage.getItem('showOutlook') === 'true' ? true : false,
            }, () => {
                //this.showEvents();
                this.props.renderLoading();
                this.callOverrideRows()})
        }

        if (this.props.getBadgeSuccess && !prevProps.getBadgeSuccess) {
            let color = this.props.colorData.badgeColor.liveliColor !== null
                ? this.props.colorData.badgeColor.liveliColor
                : '#7200DA';
            this.setState({
                liveliColor: color,
                calendars: [
                    {
                        id: 'liveli',
                        name: 'Liveli',
                        color: '#ffffff',
                        bgColor: color,
                        dragBgColor: color,
                        borderColor: color
                    }
                ]
            }, () => this.setColors())

            localStorage.setItem('outlookColor', this.props.colorData.badgeColor.outlook)
            localStorage.setItem('emailGoogle', this.props.colorData.emailCalendar.google)
            localStorage.setItem('emailOutlook', this.props.colorData.emailCalendar.outlook)
            localStorage.setItem("timezone", this.props.colorData.timeZone.timeZone);
        }

        if (this.props.getTickresSuccess && !prevProps.getTickresSuccess) {
            const tikers = this.props.tickersData.tickersData;
            localStorage.setItem('location', tikers.weather[0] ? tikers.weather[0].name : '');
        }

        if (this.props.getSettingsSuccess && !prevProps.getSettingsSuccess) {
            this.authOutlookData = this.props.credentialsData.apiOutlookconfig
            // this.authOutlookData = {
            //     "authEndpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?",
            //     "redirectUri": "https://localhost:3000/main/settings/",
            //     "appId": "8084ae22-07bf-46f3-9d1d-1d3453b9ff50", 
            //     "scopes": "openid profile User.Read Mail.Read Calendars.Read Contacts.Read"
            // }
        }
        // Rehydrate calendar
        //this.inspector();
    }

    // Removing title attr to not have tooltip in IE
    removeAttrTitle = () => {
        const el = document.querySelectorAll(`.tui-full-calendar-weekday-schedule-title`);
        el.forEach(i => {
            i.removeAttribute("title");
        });
    }

    setColors = () => {
        var calendarName = ['google', 'outlook', 'addTask'];
        var newColors = [
            { name: 'blue', color: '#4282FB'},
            { name: 'pink', color: '#FB42E7'},
            { name: 'green', color: '#1C8100'},
            { name: 'orange', color: '#FF9019'},
            { name: 'aqua', color: '#19D9FF'}
        ];
        let calendars = [];
        let calendarsColor = [];
        for (let source of calendarName) {
            var color = source === 'google' ? this.props.colorData.badgeColor.google : source === 'outlook' ? this.props.colorData.badgeColor.outlook : 'none';
            var newCalendar = {
                id: source,
                name: source.charAt(0).toUpperCase() + source.slice(1),
                color: '#ffffff',
                bgColor: color,
                dragBgColor: color,
                borderColor: source === 'google' ? this.props.colorData.badgeColor.google : source === 'outlook' ? this.props.colorData.badgeColor.outlook : 'transparent'
            }
            calendars.push(newCalendar)
        }

        for (let calendar of newColors) {
            var newCalendarColor = {
                id: calendar.name,
                name: calendar.name,
                color: '#ffffff',
                bgColor: calendar.color,
                dragBgColor: calendar.color,
                borderColor: calendar.color
            }
            calendarsColor.push(newCalendarColor)
        }

        this.setState({
            calendars: [
                ...this.state.calendars,
                ...calendars,
                ...calendarsColor
            ]
        })
    }

    closeModal = () => this.setState({ viewModalCalendar: false }, () => this.renderAfterCloseModal());

    renderAfterCloseModal = () => {
        this.props.renderDone();
        window.location.reload();
    }

    eventsGoogle = () => {
        if (this.props.colorData.badgeColor.google !== null && this.props.colorData.emailCalendar.google !== 'null') {
            if (!this.state.showGoogle){
                if (ApiCalendar.sign) {
                    var date = new Date(this.state.date.year, this.state.date.month).toISOString()
                    ApiCalendar.listUpcomingEvents(200, date)
                        .then(({ result }) => {
                            if (result.summary === this.props.colorData.emailCalendar.google ){
                                localStorage.setItem('showGoogle', 'true')
                                this.setState({ showGoogle: true, isFirstUpdate: true },
                                () => this.convertEvents(result.items, 'google'))
                            }
                            else {
                                this.setState({
                                    viewModalCalendar: true,
                                    calendarSource: 'Google',
                                    syncEmail: this.props.colorData.emailCalendar.google,
                                    browserEmail: result.summary
                                }, () => this.props.renderDone())
                            }
                        });
                }
                else ApiCalendar.handleAuthClick();
            }
            else{
                this.setState({
                    showGoogle: false
                },
                    () => this.showEvents()
                )
                localStorage.setItem('showGoogle', 'false')
            }
        }
        else {
            this.props.handleOpenModal()
        }
    }

    theme = {
        'common.saturday.color': '#333',
        'common.holiday.color': '#333',
        'month.dayname.height': '30px',
        'month.dayname.paddingLeft': '8px',
        'month.dayname.fontSize': '12px',

        'month.holidayExceptThisMonth.color': "#bbb",
        'month.dayExceptThisMonth.color': '#bbb',
        'month.weekend.backgroundColor': 'white',
        'month.day.fontSize': '16px',
        'month.day.padding': '8px',
        'month.schedule.backgroundColor': "#9e5fff",

        'week.daygridLeft.width': '105px',
        'week.timegridLeft.width': '105px',
    }


    convertEvents = (events, source) => {
        let eventsList = [];
        if (source === 'google') {
            for (let e of events) {
                let newEvent = {
                    body: '',
                    calendarId: source,
                    category: 'time',
                    end: e.end.dateTime ? moment(e.end.dateTime).toISOString() : moment(e.start.date).toISOString(),
                    id: e.id,
                    start: e.start.dateTime ? moment(e.start.dateTime).toISOString() : moment(e.start.date).toISOString(),
                    title: e.summary,
                    isAllDay: e.start.dateTime  ? false : true
                }
                eventsList.push(newEvent)
            }
            localStorage.setItem('eventsGoogle', JSON.stringify(eventsList))
        }
        else if (source === 'outlook') {
            for (let e of events) {
                let newEvent = {
                    body: '',
                    calendarId: source,
                    category: 'time',
                    end: e.isAllDay ? moment(e.start.dateTime).toISOString() : moment(e.end.dateTime+"Z").toISOString(),
                    id: Math.random().toString(36).substr(2, 9),
                    start: e.isAllDay ? moment(e.start.dateTime).toISOString() : moment(e.start.dateTime+"Z").toISOString(),
                    title: e.subject,
                    isAllDay: e.isAllDay
                }
                if (e.recurrence !== null) {
                    const repetitions = this.outlookRecurrence(e, newEvent);
                    eventsList = eventsList.concat(repetitions);
                } else {
                    eventsList.push(newEvent)
                }
            }
            localStorage.setItem('eventsOutlook', JSON.stringify(eventsList))
        }
        this.setState({
            eventsOutlook: JSON.parse(localStorage.getItem('eventsOutlook')),
            eventsGoogle: JSON.parse(localStorage.getItem('eventsGoogle'))
        },
        () => this.showEvents()
        )

    }

    outlookRecurrence = (originalEvent, newEvent) => {
        const { recurrence } = originalEvent;
        const eventStart = moment(newEvent.start).toDate();
        const until = recurrence.range.type === 'noEnd' ?
            moment(eventStart).add(2, 'year') :
            moment(recurrence.range.endDate).set({hour: eventStart.getHours(), minutes: eventStart.getMinutes()});
        let recurrenceObject = {
            dtstart:  eventStart,
            until: until.toDate(),
            interval: recurrence.pattern.interval ? recurrence.pattern.interval : '',
            wkst: 0
        }

        if (recurrence.pattern.type) {
            switch (recurrence.pattern.type){
                case 'daily':
                    recurrenceObject.freq = Frequency.DAILY;
                    break;
                case 'weekly':
                    recurrenceObject.freq = Frequency.WEEKLY;
                    if (recurrence.pattern.daysOfWeek) {
                        let byweekday = [];
                        recurrence.pattern.daysOfWeek.forEach(element => {
                            switch(element) {
                                case 'monday':
                                    byweekday.push(RRule.MO)
                                    break;
                                case 'tuesday':
                                    byweekday.push(RRule.TU)
                                    break;
                                case 'wednesday':
                                    byweekday.push(RRule.WE)
                                    break;
                                case 'thursday':
                                    byweekday.push(RRule.TH)
                                    break;
                                case 'friday':
                                    byweekday.push(RRule.FR)
                                    break;
                                case 'saturday':
                                    byweekday.push(RRule.SA)
                                    break;
                                case 'sunday':
                                    byweekday.push(RRule.SU)
                                    break;
                                default:
                                    break;
                            }
                            recurrenceObject.byweekday = byweekday;
                        });
                    }
                    break;
                case 'absoluteYearly':
                    recurrenceObject.freq = Frequency.YEARLY;
                    break;
                case 'absoluteMonthly':
                    recurrenceObject.freq = Frequency.MONTHLY;
                    break;
                default:
                    break;
            }

            const recurrenceRule = calendarFunctions.generateRRule(recurrenceObject).toString();
            const event = {
                ...newEvent,
                recurrenceRule
            };
            const repetitions = calendarFunctions.generateEventsFromRecurrence(event);
            return repetitions;
        }
        return []
    }

    showEvents = () => {
        const { addTaskButtons } = this.state;
        if (this.state.showGoogle && !this.state.showOutlook) {
            this.setState({
                allEvents: [
                    ...this.state.myEvents,
                    ...addTaskButtons,
                    ...this.state.eventsGoogle
                ]
            })
        }
        if (!this.state.showGoogle && this.state.showOutlook) {
            this.setState({
                allEvents: [
                    ...this.state.myEvents,
                    ...addTaskButtons,
                    ...this.state.eventsOutlook
                ]
            })
        }
        else if (this.state.showGoogle && this.state.showOutlook) {
            this.setState({
                allEvents: [
                    ...this.state.myEvents,
                    ...addTaskButtons,
                    ...this.state.eventsGoogle,
                    ...this.state.eventsOutlook
                ]
            })
        }
        else if (!this.state.showGoogle && !this.state.showOutlook) {
            this.setState({
                allEvents: [...this.state.myEvents, ...this.state.addTaskButtons]
            })
        }
        this.props.renderLoading()
        this.callOverrideRows();
    }

    getOutlookEvents = () => {
        var aToken = interceptor.getValue('accessTokenOutlook');
        if (this.props.colorData.badgeColor.outlook !== null) {
            if (!this.state.showOutlook){
                if (aToken) {
                    var client = Client.init({
                        authProvider: (done) => {
                            // Just return the token
                            done(null, aToken);
                        }
                    });

                    client.api("/me").get((err, res) => {
                        if (err) {
                            console.log(err);
                            localStorage.removeItem('accessTokenOutlook');
                            localStorage.removeItem('id_tokenOutlook');
                            this.loginOutlook()
                        } else {
                            if (res.userPrincipalName === this.props.colorData.emailCalendar.outlook){
                                //var dt= moment().subtract(2, 'month').add(1, 'day').format();
                                client
                                .api('/me/events')
                                .top(200)                       
                                .select('subject,start,end,createdDateTime,IsAllDay,recurrence,IsCancelled')
                                .orderby('createdDateTime DESC')
                                .get((err, response) => {
                                    if (err && !err.statusCode !== 200) {
                                        if (err.statusCode === 401) {
                                            console.log(err);
                                            localStorage.removeItem('accessTokenOutlook');
                                            localStorage.removeItem('id_tokenOutlook');
                                            this.loginOutlook()
                                        }
                                    }
                                    else {
                                        this.setState({ showOutlook: true, isFirstUpdate: true} , 
                                            () => {
                                            localStorage.setItem('showOutlook',  'true');
                                            this.convertEvents(response.value, 'outlook');
                                        })
                                    }
                                });
                            // Create a Graph client
                            }
                            else {
                                this.setState({
                                    viewModalCalendar: true,
                                    calendarSource: 'Outlook',
                                    syncEmail: this.props.colorData.emailCalendar.outlook,
                                    browserEmail: res.userPrincipalName
                                }, () => this.props.renderDone())
                            }
                        }
                    });
                }
                else {
                    //launch authentication in a hidden iframe and then get the events
                    this.loginOutlook();
                }
            }
            else {
                this.setState({
                    showOutlook: false
                },
                    () => this.showEvents()
                )
                localStorage.setItem('showOutlook', 'false')
            }
        }
        else {
            this.props.handleOpenModal()
        }
    }

    buildOutlookUrl = () => {
        if (this.state.isOutlookAuthenticated)
            return;

        // Generate random values for state
        sessionStorage.authState = Math.random().toString(36).substr(2, 9);
        sessionStorage.authNonce = Math.random().toString(36).substr(2, 9);

        var authParams = {
            response_type: 'id_token token',
            client_id: this.authOutlookData.appId,
            redirect_uri: this.authOutlookData.redirectUri,
            scope: this.authOutlookData.scopes,
            state: sessionStorage.authState,
            nonce: sessionStorage.authNonce,
            response_mode: 'fragment'
        };
        return this.authOutlookData.authEndpoint + Object.entries(authParams).map(e => e.join('=')).join('&');
    }

    loginOutlook = () => {
        var windowUrl = this.buildOutlookUrl();
        window.open(windowUrl, "_blank");
        setTimeout(() => {
            this.checkForToken();
        }, 100);
    }

    checkForToken = () => {
        var aToken = interceptor.getValue('accessTokenOutlook');
        if (aToken) {
            this.getOutlookEvents();
        }
        else {
            setTimeout(() => {
                this.checkForToken();
            }, 100);
        }
    }

    getMinimumHour = (start, end, isFirstTime = false) => {
        let minHour = 6, events
        if (this.state.view === 'month') {
            return minHour
        }
        events = isFirstTime ? this.props.eventsToShow : this.state.myEvents
        const filter = events.filter( ev => ev.isAllDay === false && ev.category === 'time' && (ev.start >= start.toISOString() && ev.end <= end.toISOString()))
        if (filter.length > 0) {
            let min = Math.min.apply(null, filter.map(item => moment(item.start).hour()))
            minHour = min > 6 ? minHour : min
        }
        return minHour
    }

    updateRange = (shouldFetchEvents = false, initializing = false, nextOrPrevClicked = false) => {
        const calendarInstance = this.calendarRef.current.getInstance();
        if (initializing || (this.state.view === 'week' && !nextOrPrevClicked)) {
            calendarInstance.setDate(moment(this.props.defaultDate).toDate())
        }
        const start = moment(calendarInstance.getDateRangeStart().toDate());
        const end = moment(calendarInstance.getDateRangeEnd().toDate());
        const currentMonth = start.clone().add(10, 'd');
        let addTaskButtons = [];
        const hourStart = this.getMinimumHour(start, end)

        let rangeLabel = '';
        switch (this.state.view) {
            case 'day':
                calendarInstance.scrollToNow()
                rangeLabel = start.format('MMMM D, YYYY');
                addTaskButtons = calendarFunctions.createTaskWeek(start.clone(), 'day', 'task');
                this.setState({
                    addTaskButtons,
                    hourStart,
                    allEvents: [
                        ...this.state.myEvents,
                        ...addTaskButtons,
                        ...localStorage.getItem('showGoogle') === 'true' ? JSON.parse(localStorage.getItem('eventsGoogle')) : [],
                        ...localStorage.getItem('showOutlook') === 'true' ? JSON.parse(localStorage.getItem('eventsOutlook')) : [],
                    ]
                })
                this.props.setDefaultView('day', start.toDate())
                break;
            case 'week':
                calendarInstance.scrollToNow()
                rangeLabel = start.format('MMMM D, YYYY') + " - " + end.format('MMMM D, YYYY');
                addTaskButtons = calendarFunctions.createTaskWeek(start.clone(), 'week', 'task');
                this.setState({
                    addTaskButtons,
                    hourStart,
                    allEvents: [
                        ...this.state.myEvents,
                        ...addTaskButtons,
                        ...localStorage.getItem('showGoogle') === 'true' ? JSON.parse(localStorage.getItem('eventsGoogle')) : [],
                        ...localStorage.getItem('showOutlook') === 'true' ? JSON.parse(localStorage.getItem('eventsOutlook')) : [],
                    ]
                });
                this.props.setDefaultView('week', start.toDate())
                break;
            case 'month':
                rangeLabel = currentMonth.format('MMMM YYYY');
                if (currentMonth.format('YYYY-MM') === moment().format('YYYY-MM')) {
                    this.props.setDefaultView('month', moment().toDate())
                } else {
                    this.props.setDefaultView('month', currentMonth.clone().set({date: 1}))
                }
                break;
            default:
                break;
        }

        if (shouldFetchEvents && this.state.view === 'month') {
            this.props.getAllEvents(currentMonth.format('YYYY-MM'))
        } else if (shouldFetchEvents) {
            this.props.getAllEvents(start.format('YYYY-MM'));
        }


        var date = {
            month: currentMonth.format('MM') - 2,
            year: parseInt(currentMonth.format('YYYY'))
        }
        this.setState({
            rangeLabel,
            date: date
        });

        if (!shouldFetchEvents) {
            this.props.renderLoading()
            this.callOverrideRows();

        }
    }

    onClickToday = () => {
        const calendarInstance = this.calendarRef.current.getInstance();
        let isSameMonth = moment(calendarInstance.getDate().toDate()).isSame(moment(), 'month');

        calendarInstance.today();
        this.setState({changeDate: true})
        this.updateRange(isSafari ? isSameMonth : !isSameMonth, false, true);
    }

    handlePrevious = () => {
        const calendarInstance = this.calendarRef.current.getInstance();
        calendarInstance.prev();
        this.setState({changeDate: true});
        this.updateRange(true, false, true);
    }

    handleNext = () => {
        const calendarInstance = this.calendarRef.current.getInstance();
        calendarInstance.next();
        this.setState({changeDate: true});
        this.updateRange(true, false, true);
    }

    onChangeView = ({ value }) => {
        this.rowResize();
        this.setState({
            view: value
        }, () => this.updateRange(isSafari ? true : false));
    }

    //holds the number of clicks
    clickCount = { value: 0, ev: null }

    handleBeforeCreateSchedule = (schedule) => {
        const calendarInstance = this.calendarRef.current.getInstance();
        schedule.viewSortKey = moment(calendarInstance.getDate().toDate()).format('YYYY-MM');
        this.props.handleCreateEvent(schedule);
    }

    createEventButton = () => {
        let schedule = {
            start: moment(),
            end: moment().clone().add(1, "hour"),
            isAllDay: false
        }
        const calendarInstance = this.calendarRef.current.getInstance();
        schedule.viewSortKey = moment(calendarInstance.getDate().toDate()).format('YYYY-MM');
        this.props.handleCreateEvent(schedule);
    }

    //generic click handler
    handleOnClickSchedule = (ev, tickerType) => {
        const calendarInstance = this.calendarRef.current.getInstance();
        calendarInstance.hideMoreView();
        if(ev.schedule.category === 'time') {
            ev.schedule.viewSortKey = moment(calendarInstance.getDate().toDate()).format('YYYY-MM');
            this.props.handleEditEvent(ev.schedule)
            return;
        }


        //if zero clicks, then start the count and schedule the handler
        if (this.clickCount.value === 0) {
            setTimeout(() => {
                //set the count to one only if the count is zer0
                if (this.clickCount.value === 0) {
                    this.clickCount.value = 1;
                    this.clickCount.ev = ev;
                    setTimeout(() => {
                        //check if it was a single click or double
                        const { schedule } = this.clickCount.ev;

                        const event = {
                            ...schedule,
                            start: moment(schedule.start),
                            end: moment(schedule.end)
                        }

                        const checkDecision = () => {
                            let className, tagName;

                            if (ev.event.toElement){
                                className  = ev.event.toElement.className;
                                tagName = ev.event.toElement.tagName;
                            }
                            else {
                                className  = ev.event.originalTarget.className;
                                tagName = ev.event.originalTarget.tagName;
                            }
                            const checking = 'iconTask iconTask--check',
                                checkingSVG = 'svg',
                                detail = 'checkLabelTask taskTitle';

                            if (className === checking || tagName === checkingSVG) {
                                this.taskSingleClick(this.clickCount.ev);
                            } 
                            else if (className === detail) {
                                this.props.showScheduleModal(event, "task", "showTaskModal", "isEditingTask", true);
                            }
                        }

                        if (this.clickCount.value === 1) { //single click
                            switch (tickerType) {
                                case 'checklist':
                                    checkDecision();
                                    break;
                                case 'weather':
                                    break;
                                case 'notes':
                                    this.props.showScheduleModal(event, 'note', 'showNoteModal', 'isEditingNote', true);
                                    break;
                                case 'reminders':
                                    this.props.showScheduleModal(event, 'reminder', 'showReminderModal', 'isEditingReminder', true);
                                    break;
                                default:
                                    return;
                            }
                        } 
                        else if (this.clickCount.value === 2) { //double click
                            switch (tickerType) {
                                case 'checklist':
                                    this.props.showScheduleModal(event, 'task', 'showTaskModal', 'isEditingTask', true);
                                    break;
                                case 'weather':
                                    break;
                                case 'notes':
                                    this.props.showScheduleModal(event, 'note', 'showNoteModal', 'isEditingNote', true);
                                    break;
                                case 'reminders':
                                    this.props.showScheduleModal(event, 'reminder', 'showReminderModal', 'isEditingReminder', true);
                                    break;
                                default:
                                    return;
                            }
                        } 
                        else {
                        }
                        //clear the value
                        this.clickCount.value = 0;
                        this.clickCount.ev = null;

                    }, 400);
                }
            }, 70);
        } else if (this.clickCount.value === 1) { //increase the count
            setTimeout(() => {
                //set the count to twp only if the count is one
                if (this.clickCount.value === 1) {
                    this.clickCount.value = 2;
                }
            }, 70);
        }
    }

    taskSingleClick = (ev) => {
        const taskToCheck = ev.schedule;

        let events = [], sortKey;

        if (taskToCheck.id.includes('recurrence_number')) {
            sortKey = "recurrentEvents"
            events = calendarFunctions.toggleCheckTaskInRecurrent(this.props.recurrentEvents, taskToCheck)
        } else {
            sortKey = moment(taskToCheck.start).format('YYYY-MM');
            events = calendarFunctions.toggleCheckTask(this.props.events, taskToCheck)
        }

        const data = {
            email: this.props.user.email,
            sortKey,
            events: calendarFunctions.removeCalendarProps(events),
            create: false,
            viewSortKey: moment(taskToCheck.start).format('YYYY-MM')
        }

        this.props.putTasks(data)

        //change the element without renderLoading again everything
        // let parent = ev.event.srcElement.parentElement;
        // if (parent.tagName === 'svg') {
        //     parent = parent.parentElement;
        // } else if (parent.className === 'checkTask') {
        //     parent = parent.getElementsByClassName('iconTask')[0];
        // }
        // for (let x in parent.childNodes) {
        //     if (parent.childNodes[x].tagName === 'svg') {
        //         if (parent.childNodes[x].classList.contains('visible')) {
        //             parent.childNodes[x].classList.remove('visible');
        //             parent.childNodes[x].classList.add('hidden');
        //         } else {
        //             parent.childNodes[x].classList.remove('hidden');
        //             parent.childNodes[x].classList.add('visible');
        //         }

        //     }
        // }
    }

    renderViewDropdown = () => {
        return (
            <ViewSelector
                onChange={this.onChangeView}
                defaultView={this.props.defaultView}
            />
        )
    }

    renderCalendarHeader = () =>
        <Row className={calendarStyles.__header} middle="xs" between="xs">
            <Col xs={12} lg={10} md={10} className={calendarStyles.__leftButtons}>
                <button className={calendarStyles.__headerButton_add} style={{marginRight: 16, display: 'flex'}}
                    onClick={() => this.createEventButton()}
                    >
                    <FaPlus size={14} color="#FFF" className={calendarStyles.__buttonPlus}/>
                    <span>Create Event</span>
                </button>
                {this.renderViewDropdown()}
                <button
                    className={calendarStyles.__headerButton}
                    onClick={this.onClickToday}
                >
                    Today
                </button>
                <button
                    className={[calendarStyles.__headerButton, calendarStyles.__iconButton].join(' ')}
                    onClick={this.handlePrevious}
                >
                    <FiChevronLeft size={14} color="#8A8A8D" />
                </button>
                <button
                    className={[calendarStyles.__headerButton, calendarStyles.__iconButton].join(' ')}
                    onClick={this.handleNext}
                >
                    <FiChevronRight size={14} color="#8A8A8D" />
                </button>
                <span className={calendarStyles.__rangeLabel}>
                    {this.state.rangeLabel}
                </span>
            </Col>
            <Col xs={12} lg={2} md={2} className={[calendarStyles.__rightButtons, 'step12-calendar'].join(' ')}>
                <button onClick={this.eventsGoogle} >
                    <img src="/images/gcalendar.png" alt="gcalendar" />
                    {
                        this.state.showGoogle &&
                        <div className={calendarStyles.__greenCircle} style={{ backgroundColor: this.props.colorData.badgeColor.google }}></div>
                    }
                </button>
                <button onClick={this.getOutlookEvents}>
                    <img src="/images/outlook.png" alt="gcalendar" />
                    {
                        this.state.showOutlook &&
                        <div className={calendarStyles.__greenCircle} style={{ backgroundColor: this.props.colorData.badgeColor.outlook }}></div>
                    }
                </button>
            </Col>
        </Row>

    handleCloseReminderModal = () => {
        if(this.props.showReminderModal){
            this.props.displayModal(false)
        }
        else{
            this.setState({ showReminderModal: false });
        }
        this.callOverrideRows();
    }

    goSettings = () => {
        window.location.href = "/main/settings";
        localStorage.setItem('menu', "settings")
    }

    clickAddBridge = (src, el, ISODateString) => {
        const tickerCatAndId = el.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('#tickerId').innerText;
        const category = tickerCatAndId.split('_')[0];
        const tickerId = tickerCatAndId.split('_')[1];

        const schedule = {
            start: moment(ISODateString),
            end: moment(ISODateString),
            category: tickerId
        }

        switch (category) {
            case 'checklist':
                this.props.showScheduleModal(schedule, 'task', 'showTaskModal', 'isEditingTask', false)
                break;
            case 'weather':
                break;
            case 'notes':
                this.props.showScheduleModal(schedule, 'note', 'showNoteModal', 'isEditingNote', false)
                break;
            case 'reminders':
                this.props.showScheduleModal(schedule, 'reminder', 'showReminderModal', 'isEditingReminder', false);
                break;
            default:
                break;
        }
    }

    clickBridge = (src, id, tickerType) => {
        //ev.event ev.schedule
        for (var t in this.state.myEvents) {
            if (this.state.myEvents[t].id === id) {
                var ev = {
                    event: src,
                    schedule: this.state.myEvents[t]
                };
                this.handleOnClickSchedule(ev, tickerType);
            }
        }
    }



    tickerCategories = {
        weather: [],
        checklist: [],
        notes: [],
        reminders: []
    }

    // /* Fix: On the Week view in Firefox and very rare on Chrome the tickers section was being replaced by a white rectangle */ 
    // inspector = () => {
    //     setTimeout(() => {
    //         const blank_splitter = document.querySelector('div.tui-full-calendar-splitter[data-panel-index="1"]');
    //         const nextEl = document.querySelector('div[data-panel-index="2"]');
    //         if(blank_splitter) {
    //             if(blank_splitter.nextElementSibling === nextEl) {
    //                 this.callOverrideRows(1000);
    //                 this.forceUpdate();
    //             }
    //         }
    //     }, 500);
    // }

    callOverrideRows = (num) => {
        if (!num) num = 300
        setTimeout(() => {
            this.overrideTopThreeRows();
            this.rowResize();
            this.removeAttrTitle();
            this.props.renderDone();
        }, num);
    }

    overrideTopThreeRows = () => {
        setTimeout(() => {
        //now hide first rows (default toast calendar) 2-5
            if (document.querySelectorAll('[data-panel-index]').length > 2) {
                //for day view we need to know the day that we are seeing
                const calendarInstance = this.calendarRef.current.getInstance();
                const start = moment(calendarInstance.getDateRangeStart().toDate());
                var EmptyElement = document.querySelectorAll('[data-panel-index]')[0].outerHTML;
                EmptyElement = EmptyElement.replace('style="height: 40px;"', 'style="height: 40px;border-bottom: 1px solid rgb(229, 229, 229);"');
                var parent = document.querySelectorAll('[data-panel-index]')[2];

                document.querySelectorAll('[data-panel-index]')[0].style.display = 'none';
                document.querySelectorAll('[data-panel-index]')[1].style.display = 'none';

                //Insert all the ticker categories that come from the profile
                this.renderTickerSection(parent, EmptyElement, start, 'weather');
                this.renderTickerSection(parent, EmptyElement, start, 'checklist');
                this.renderTickerSection(parent, EmptyElement, start, 'notes');
                this.renderTickerSection(parent, EmptyElement, start, 'reminders');

                //== Adding class to visualize tickers
                var el = document.querySelectorAll('div[data-panel-index="0"]');
                el.forEach(i => {
                    i.classList.remove('hide-element');
                });

                //subscribe the add ticker buttons
                var allAddT = document.getElementsByClassName('addNewTicker');
                let btnCounter = 1, btnDate = start.clone();
                for (var tt = 0; tt < allAddT.length; tt++) {
                    const additionDate = btnDate.clone();
                    setTimeout((btn, that) => {
                        btn.onclick = function (src) {
                            that.clickAddBridge(src, btn, additionDate.toISOString());
                        };
                        btn.classList.add('hidden');
                    }, 55, allAddT[tt], this);
                    var parentHover = allAddT[tt].parentElement.parentElement.parentElement.parentElement;
                    setTimeout((btn, container) => {
                        container.onmouseenter = function () {
                            btn.classList.add('visible');
                            btn.classList.remove('hidden');
                        };
                        container.onmouseleave = function () {
                            btn.classList.add('hidden');
                            btn.classList.remove('visible');
                        };
                    }, 55, allAddT[tt], parentHover);

                    // Attach the date for the addition click
                    if (btnCounter !== 7 && this.state.view !== 'day') {
                        btnDate.add(1, 'day');
                        btnCounter++;
                    } else {
                        btnCounter = 1;
                        btnDate = start.clone();
                    }
                }
            }
        }, 50);
    }

    renderTickerSection = (parent, emptyElement, start, tickerCategory) => {
        const userTickerCategory = this.props.userProfile[tickerCategory];

        if (userTickerCategory) {
            for (var x = 0; x < userTickerCategory.length; x++) {
                const ticker = userTickerCategory[x];
                if (!ticker.active)
                    continue;
                    var newRow = document.createElement('div');
                newRow.innerHTML = emptyElement.replace('My tasks', '<br/>' + ticker.name +
                    `<label style="display:none" id="tickerId">${tickerCategory}_${ticker.id}</label>`);
                this.tickerCategories[tickerCategory].push({id: ticker.id, name: ticker.name});
                let _newRow = null
                _newRow = newRow.querySelector(".tui-full-calendar-task-left")
                if (_newRow !== null) _newRow.setAttribute('title', ticker.name);

                parent.parentNode.insertBefore(newRow, parent);
                var days = newRow.getElementsByClassName('tui-full-calendar-weekday-schedule-block');
                if(tickerCategory ==='weather'){
                    for(var el=0; el < days.length; el++){
                        days[el].innerHTML = '';
                    }
                }
                //Fill all the elements.
                var rowCount = 0;
                let startClone = start.clone();
                const tickerElements = this.state.myEvents.filter( ev => ev.category === ticker.id);

                for (let i = 0; i < days.length; i++) {
                    const dayElements = tickerElements.filter(t => moment(t.start).format('YYYY-MM-DD') === startClone.format('YYYY-MM-DD'));

                    if (dayElements.length > 0) {
                        for (let index = 0; index < dayElements.length; index++) {
                            const element = dayElements[index];
                            var content = null;
                            switch (tickerCategory) {
                                case 'checklist':
                                        content = checkTemplate(element, tickerCategory);
                                    break;
                                case 'weather':
                                        content = weatherTemplate(element,tickerCategory);
                                    break;
                                case 'notes':
                                        content = noteTemplate(element)
                                    break;
                                case 'reminders':
                                        content = reminderTemplate(element)
                                    break;
                                default:
                                    break;
                            }

                            days[i].innerHTML = days[i].innerHTML + content;
                            //we need to wait a little bit inorder to subscribe
                            //we need to wait a little bit inorder to subscribe
                            //we need to wait a little bit inorder to subscribe
                            if (tickerCategory !== 'weather') {
                                setTimeout((id, that) => {
                                    var el = document.getElementById(id);
                                    if (el !== null) {
                                        el.onclick = function (src) {
                                                that.clickBridge(src, id, tickerCategory);
                                            };
                                        } else {
                                            this.props.renderLoading();
                                            this.callOverrideRows();
                                    }
                                }, 60, element.id, this);
                            }
                        }
                    }
                    startClone.add(1, 'day');
                }

                for (var t in days) {
                    if (!days[t].childNodes)
                        continue;
                    rowCount = rowCount < days[t].childNodes.length ? days[t].childNodes.length : rowCount;
                }

                //recalculate the height
                let numTask = Math.round((rowCount - 1) / 2)
                rowCount = numTask > 1 ? (numTask * 29) : 40
                //reset the content and the heigth, this is neccesary to make the calendar look the same as the built in elements
                newRow.outerHTML = newRow.innerHTML.replace('style="height: 40px;border-bottom: 1px solid rgb(229, 229, 229);"', 'style="height: ' + rowCount + 'px;border-bottom: 1px solid rgb(229, 229, 229); max-height: 116px;"');

            }
        }
    }

    dragAndDropEvent = (ev) => {
        let startDate = !ev.changes.start ? ev.schedule.start._date.toISOString() : ev.changes.start._date.toISOString();
        let endDate = !ev.changes.end ? ev.schedule.end._date.toISOString() : ev.changes.end._date.toISOString();
        if (ev.schedule.end._date.toISOString() === ev.changes.end._date.toISOString() || ev.schedule.calendarId === 'google' || ev.schedule.calendarId === 'outlook'){
            return;
        }

        let newEvent = {
            id: ev.schedule.id,
            title: ev.schedule.title,
            body: ev.schedule.body,
            location: ev.schedule.location,
            calendarId: ev.schedule.calendarId,
            category: 'time',
            start: startDate,
            end: endDate,
            isAllDay: ev.schedule.isAllDay,
            recurrenceRule: ev.schedule.recurrenceRule
        };

        let sortKey, newEvents = [];
        let previousSortKey = moment(ev.schedule.start.toDate()).format('YYYY-MM');
        sortKey = moment(newEvent.start).format('YYYY-MM');

        if ( ev.schedule.raw.reminderString != null ) {
            const reminderDate = moment(newEvent.start).local().clone();
            newEvent = {
                ...newEvent,
                reminderDate: reminderDate.toISOString(),
                reminderString: ev.schedule.raw.reminderString
            }
        }

        let reminderScheduleId = "isNew";
        let reminderHasChenged = false;
        const reminderDate = moment(newEvent.start).local().clone();

        if ( ev.schedule.raw.reminderString != null ) {

            this.props.events.forEach( e => {
                if (e.id === newEvent.id) {
                    reminderScheduleId = e.reminderScheduleId;
                    if (e.start !== newEvent.start || e.reminderDate !== reminderDate.toISOString() || e.reminderString !== ev.schedule.raw.reminderString)
                        reminderHasChenged = true;
                }
            })

            this.props.recurrentEvents.forEach(recc => {
                if (recc.id === newEvent.id) {
                    reminderScheduleId = recc.reminderScheduleId;
                    if (recc.start !== newEvent.start || recc.reminderDate !== reminderDate.toISOString() || recc.reminderString !== ev.schedule.raw.reminderString)
                        reminderHasChenged = true;
                }
            })

            if (reminderScheduleId !== "isNew")
                newEvent = {
                    ...newEvent,
                    reminderDate: reminderDate.toISOString(),
                    reminderString: ev.schedule.raw.reminderString,
                    reminderScheduleId,
                    reminderHasChenged
                }
            else
                newEvent = {
                    ...newEvent,
                    reminderDate: reminderDate.toISOString(),
                    reminderString: ev.schedule.raw.reminderString
                }
        }
        else {
            this.props.events.forEach(e => {
                if (e.id === newEvent.id) {
                    if (reminderScheduleId !== ''){
                        newEvent = {
                            ...newEvent,
                            reminderScheduleId: e.reminderScheduleId,
                            reminderHasChenged: true
                        }
                    }
                }
            })

            this.props.recurrentEvents.forEach(recc => {
                if (recc.id === newEvent.id) {
                    if (reminderScheduleId !== ''){
                        newEvent = {
                            ...newEvent,
                            reminderScheduleId: ev.reminderScheduleId,
                            reminderHasChenged: true
                        }
                    }
                }
            })
        }

        if ( ev.schedule.recurrenceRule !== '' ) {
            let recurrentEvents = this.props.recurrentEvents;
            newEvents = calendarFunctions.updateUniqueEventInRecurrency(recurrentEvents, ev.schedule, newEvent);
            sortKey = 'recurrentEvents';
        }
        else {
            if (previousSortKey !== sortKey) {
                // Remove event from original sortKey Events
                const eventsWithoutUpdated = calendarFunctions.removeEvent(this.props.events, newEvent);
                this.executeUpdate(previousSortKey, eventsWithoutUpdated, false, previousSortKey);

                // Create event in new SortKey
                this.executeUpdate(sortKey, [newEvent], true, previousSortKey);
                return;
            }
            else {
                newEvents = calendarFunctions.putUpdatedEvent(this.props.events, newEvent)
            }
        }
        this.executeUpdate(sortKey, newEvents, false, previousSortKey)
    }

    executeUpdate = (sortKey, events, create, viewSortKey) => {
        const data = {
            email: this.props.user.email,
            sortKey,
            events: calendarFunctions.removeCalendarProps(events),
            create: create,
            viewSortKey: viewSortKey
        }
        this.props.createEvent(data)
    }

    renderConfirmationModal = () => {
        return(
            <ConfirmationModal
                title={"Email account not match"}
                label={
                    "Sorry, we can't sync your calendar. You have an open " + this.state.calendarSource +
                    " session with a different account than the one that you have registered on Liveli's settings (" +
                    this.state.syncEmail + ")."
                }
                secondLabel={
                    "You can change Liveli's settings to match your current " + this.state.browserEmail + " " +
                    this.state.calendarSource + " session or logout from your current session and login with the account that you registered on Liveli (" +
                    this.state.syncEmail + ")."
                }
                cancelText={"OK"}
                confirmText={"Go to settings"}
                onConfirm={this.goSettings}
                goToSettings={true}
                onClose={this.closeModal}
                isEmailNoMatch={true}
            />
        )
    }

    render() {
        ApiCalendar.listUpcomingEvents = function (maxResults, startDate) {
            if (this.gapi) {
                return  this.gapi.client.calendar.events.list({
                    'calendarId': 'primary',
                    'timeMin': startDate,
                    'showDeleted': false,
                    'singleEvents': true,
                    'maxResults': maxResults,
                    'orderBy': 'startTime'
                });
            } else {
                console.log("Error: this.gapi not loaded");
                return false;
            }
        }

        //refresh the token
        return (
            <Col xs={12} style={{ height: '100%' }}>
                {this.state.viewModalCalendar && this.renderConfirmationModal()}
                {this.renderCalendarHeader()}
                <Row middle="xs" className={[calendarStyles.__calendarContainer].join(' ')}>
                    <Col xs={12} className={[calendarStyles.__calendar, 'step11-calendar'].join(' ')}>
                        <Calendar
                            ref={this.calendarRef}
                            onRateChange
                            calendars={this.state.calendars}
                            disableDblClick={true}
                            disableClick={false}
                            isReadOnly={false}
                            month={{
                                startDayOfWeek: 0 ,
                                isAlways6Week: false
                            }}
                            scheduleView={this.props.loading ? ['time'] : true}
                            taskView={this.props.loading ?  false : ['task']}
                            // useDetailPopup
                            view={this.state.view}
                            schedules={this.state.allEvents}
                            // schedules={this.state.addTask}
                            theme={this.theme}
                            onClickSchedule={this.handleOnClickSchedule}
                            onBeforeCreateSchedule={this.handleBeforeCreateSchedule}
                            onBeforeUpdateSchedule={(ev) => this.dragAndDropEvent(ev)}
                            //week= {{ hourStart: this.state.hourStart }}
                            template={{
                                task: (task) => taskTemplate(task),
                                taskTitle: function () {
                                    return '<span class="tui-full-calendar-left-content">My tasks</span>';
                                },
                                milestoneTitle: function () {
                                    return '<span class="tui-full-calendar-left-content" style="display: block">[Title]</span>';;
                                },
                                timegridCurrentTime: function(timezone) {
                                    var templates = [];
                                    if (timezone.dateDifference) {
                                        templates.push('[' + timezone.dateDifferenceSign + timezone.dateDifference + ']<br>');
                                    }
                                    templates.push(moment(new Date()).format('hh:mm A'));
                                    return templates.join('');
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        userProfile: state.userReducer.userProfile,
        events: state.eventsReducer.events,
        recurrentEvents: state.eventsReducer.recurrentEvents,
        eventsToShow: state.eventsReducer.eventsToShow,
        errorType: state.eventsReducer.errorStatus,
        eventsError: state.eventsReducer.eventsError,
        errorMessage: state.eventsReducer.errorMessage,
        loading: state.eventsReducer.loading,
        allForecastsFetched: state.eventsReducer.allForecastsFetched,
        getTickresSuccess: state.tickersReducer.getTickresSuccess,
        tickersData: state.tickersReducer.tickersData,
        credentialsData: state.userReducer.credentialsData,
        getBadgeSuccess: state.userReducer.getBadgeSuccess,
        getSettingsSuccess: state.userReducer.getSettingsSuccess,
        colorData: state.userReducer.colorData,
        defaultView: state.userReducer.defaultView,
        defaultDate: state.userReducer.defaultDate,
        saving: state.eventsReducer.saving,
        updateEventsSuccess: state.eventsReducer.updateEventsSuccess
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllEvents: (sort) => dispatch(getAllEvents(sort)),
        createEvent: (data) => dispatch(createEvent(data)),
        getAllUsers: () => dispatch(getAllUsers()),
        getBadgeColor: (userData) => dispatch(getBadgeColor(userData)),
        getSettingsCredentials: () => dispatch(getSettingsCredentials()),
        getTickers: (userData) => dispatch(getTickers(userData)),
        putTasks: (data) => dispatch(createEvent(data)),
        setDefaultView: (view, date) => dispatch(setDefaultView(view, date)),
        renderLoading: () => dispatch(renderLoading()),
        renderDone: () => dispatch(renderDone())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TUICalendar)


